// Light/dark theme. The choice is saved only once the person presses the
// toggle; until then the device setting decides, and follows it if it changes.
// index.html runs the same first step inline so there is no flash on load;
// this module repeats it in case that inline script was blocked.
import { useSyncExternalStore } from 'react';
import { readPref, writePref } from './sharedPrefs';

const PREF = 'jawabai_theme';
const query = window.matchMedia('(prefers-color-scheme: light)');

// The choice shared with the other jawabai sites (cookie), else this browser's.
function saved() {
  return readPref(PREF);
}

function current() {
  return document.documentElement.getAttribute('data-theme') === 'light'
    ? 'light'
    : 'dark';
}

const listeners = new Set();

function apply(theme) {
  document.documentElement.setAttribute('data-theme', theme);
  listeners.forEach((fn) => fn());
}

apply(saved() || (query.matches ? 'light' : 'dark'));
// Mirror a choice that only exists in localStorage so the other sites see it.
if (saved()) writePref(PREF, saved());

query.addEventListener('change', (e) => {
  if (!saved()) apply(e.matches ? 'light' : 'dark');
});

export function setTheme(theme) {
  writePref(PREF, theme);
  apply(theme);
}

export function useTheme() {
  const theme = useSyncExternalStore(
    (fn) => {
      listeners.add(fn);
      return () => listeners.delete(fn);
    },
    current,
  );
  return [theme, setTheme];
}
